module.exports = __webpack_public_path__ + "assets/1d1c919a30f973dcab5d67287c2ebb9a.mp3";